/* eslint-disable max-len */
import { SvgProps } from './types'

export const MoneyRisingIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg 
      width="64" 
      height="64" 
      viewBox="0 0 64 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_333_11680)">
        <path d="M44.9863 33.6862V22.6452H55.5781V33.2686" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M32.4334 55.7556H30.2695V29.2698H40.8676V35.1352" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M26.1509 55.7556V35.8881H15.5527V55.7556" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M0.841797 55.7556V42.5127H11.4336V55.7556" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M39.1462 21.1773L50.8262 9.75661L52.4334 14.9133L56.8877 0.835205L42.816 5.29591L48.2637 6.99161L37.7352 17.2607H27.8647L18.8421 26.2834H1.2207" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M46.373 54.7559C47.126 55.7366 48.4484 56.3883 49.9543 56.3883C52.2953 56.3883 54.1872 54.8191 54.1872 52.8767C54.1872 50.6621 52.0992 49.7447 50.258 49.3777C48.6129 49.0487 46.8096 48.1439 46.8096 46.2014C46.8096 44.4425 48.5306 43.0125 50.6566 43.0125C52.0043 43.0125 53.1938 43.5883 53.8772 44.4614" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M50.2773 58.8306V56.382" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M50.2773 40.3994V42.9935" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M62.992 51.6896C64.1314 44.6703 59.3648 38.0563 52.3454 36.9169C45.3261 35.7775 38.7122 40.5441 37.5728 47.5634C36.4334 54.5828 41.2 61.1967 48.2193 62.3361C55.2386 63.4755 61.8526 58.7089 62.992 51.6896Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_333_11680">
          <rect width="64" height="63.342" fill={drawColor} transform="translate(0 -0.0078125)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
